var map = {
	"./calendar.webp": 1523,
	"./cash.webp": 1524,
	"./check-in-title-bg.webp": 1525,
	"./coin.webp": 1526,
	"./current-check-in-container.webp": 1527,
	"./current-last-day-check-in-container.webp": 1528,
	"./daily-check-in-bg.webp": 1529,
	"./default-check-in-container.webp": 1530,
	"./giftbox.webp": 1531,
	"./golden-coin.webp": 1532,
	"./halfweek-check-in-container.webp": 1533,
	"./last-day-check-in-container.webp": 1534,
	"./missed-checkIn.webp": 1535,
	"./more-cash.webp": 1536,
	"./more-coin.webp": 1537,
	"./more-spin.webp": 1538,
	"./need-deposit.webp": 1539,
	"./present.webp": 1540,
	"./reward-coin.webp": 1541,
	"./shine.webp": 1542,
	"./silver-coin.webp": 1543,
	"./spin.webp": 1544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 151;